import { ILoggingService } from "@/services/logger/logging-service";

export class ConsoleLoggingService implements ILoggingService {
  private static instance: ConsoleLoggingService;

  public static getInstance(): ConsoleLoggingService {
    if (!ConsoleLoggingService.instance) {
      ConsoleLoggingService.instance = new ConsoleLoggingService();
    }
    return ConsoleLoggingService.instance;
  }

  logError(error: Error): void {
    if (process.env.NODE_ENV === "development") {
      console.error(error);
    }
  }
}
